app.factory('medicalPostService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function MedicalPostService() {

            this.getMedicalChamberList = function () {
                return baseService.get('edm/resource/mock/medicalChamber.json').then(
                    function (successResponse) {
                        return successResponse.data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new MedicalPostService();
    }
]);
